import { asText } from '@prismicio/helpers';
import camelcaseKeys from 'camelcase-keys';

export function transformProperties(rawData) {
  return camelcaseKeys(rawData, { deep: true, exclude: ['link_type', '_meta'] });
}

export async function getSlicesContext(slices = [], components = {}) {
  return Promise.all(
    slices.map(async (slice, index) => {
      const { slice_type: sliceType } = slice;

      let context = {};
      if (typeof components[sliceType] !== 'undefined') {
        const sliceTypeFunction = components[sliceType];
        context = await sliceTypeFunction({ slice, index, slices });
      }

      return {
        ...slice,
        context,
      };
    })
  );
}

export function fieldHasContent(field) {
  let fieldValue = field || '';
  if (Array.isArray(field)) {
    fieldValue = asText(field);
  }
  return fieldValue.trim().length > 0;
}

export function getImageDimensions(image = {}) {
  const { url: imageUrl = '', dimensions = {} } = image || {};

  // Render half dimensions for 2x images
  if (decodeURIComponent(imageUrl).indexOf('@2x') !== -1) {
    return {
      width: dimensions.width / 2,
      height: dimensions.height / 2,
    };
  }

  return dimensions;
}
